// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The WinIQ report layout, on screen and in print. */
.wq-page {
  --wq-navy: #15233f;
  --wq-gold: #d4a53a;
  --wq-mist: #eff3f7;
  --wq-rule: #dde4ec;
  --wq-ink-2: #5b6b82;
  width: 100%;
  max-width: 816px;
  background: #fff;
  color: var(--wq-navy);
  box-shadow: 0 2px 14px rgba(17, 17, 58, 0.14);
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 13.5px;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.wq-bar {
  height: 14px;
  background: var(--wq-navy);
}
.wq-in {
  padding: 34px 56px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
}
.wq-in p {
  margin: 0;
}
.wq-brand {
  font-weight: 800;
  font-size: 24px;
  letter-spacing: 0.01em;
  line-height: 1;
}
.wq-brand span {
  color: var(--wq-gold);
}
.wq-kicker {
  color: var(--wq-gold);
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}
.wq-title {
  color: inherit;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.15;
  margin: 0;
  letter-spacing: -0.01em;
  text-wrap: balance;
}
.wq-line {
  color: var(--wq-ink-2);
  font-size: 13px;
}
.wq-kv {
  width: 100%;
  border-collapse: collapse;
}
.wq-kv td {
  padding: 9px 12px;
  border-bottom: 1px solid var(--wq-rule);
  vertical-align: top;
}
.wq-kv td:first-child {
  width: 32%;
}
.wq-h {
  color: inherit;
  font-size: 16px;
  font-weight: 800;
  margin: 6px 0 0;
}
.wq-list {
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.wq-list li {
  list-style: disc;
}
.wq-list li::marker {
  color: var(--wq-gold);
}
.wq-table {
  width: 100%;
  border-collapse: collapse;
}
.wq-table th {
  text-align: left;
  font-weight: 700;
  background: var(--wq-mist);
  padding: 8px 12px;
  border-bottom: 1px solid var(--wq-rule);
  font-size: 12.5px;
}
.wq-table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--wq-rule);
  vertical-align: top;
}
.wq-table .st {
  color: var(--wq-ink-2);
  font-size: 12px;
  white-space: nowrap;
}
.wq-note {
  color: var(--wq-ink-2);
  font-size: 12px;
}
.wq-foot {
  margin: 0 56px;
  border-top: 1px solid var(--wq-rule);
  padding: 8px 0 14px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 11px;
  color: var(--wq-ink-2);
}

#brief-print-root {
  display: none;
}

@media print {
  @page {
    size: letter;
    margin: 0;
  }
  /* An open modal locks the page scroll, which would cut the printout to one page. */
  html,
  body {
    height: auto !important;
    overflow: visible !important;
    background: #fff !important;
  }
  #root,
  .MuiModal-root,
  .Toastify {
    display: none !important;
  }
  #brief-print-root {
    display: block !important;
  }
  #brief-print-root .wq-page {
    box-shadow: none;
    max-width: none;
    min-height: 11in;
    page-break-after: always;
    break-after: page;
    print-color-adjust: exact;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Brief/brief.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;EAC7C,2DAA2D;EAC3D,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,uCAAuC;EACvC,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,SAAS;EACX;EACA,mFAAmF;EACnF;;IAEE,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;;;IAGE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,wBAAiB;IAAjB,iBAAiB;IAEjB,yBAAyB;EAC3B;AACF","sourcesContent":["/* The WinIQ report layout, on screen and in print. */\n.wq-page {\n  --wq-navy: #15233f;\n  --wq-gold: #d4a53a;\n  --wq-mist: #eff3f7;\n  --wq-rule: #dde4ec;\n  --wq-ink-2: #5b6b82;\n  width: 100%;\n  max-width: 816px;\n  background: #fff;\n  color: var(--wq-navy);\n  box-shadow: 0 2px 14px rgba(17, 17, 58, 0.14);\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 13.5px;\n  line-height: 1.5;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n.wq-bar {\n  height: 14px;\n  background: var(--wq-navy);\n}\n.wq-in {\n  padding: 34px 56px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n}\n.wq-in p {\n  margin: 0;\n}\n.wq-brand {\n  font-weight: 800;\n  font-size: 24px;\n  letter-spacing: 0.01em;\n  line-height: 1;\n}\n.wq-brand span {\n  color: var(--wq-gold);\n}\n.wq-kicker {\n  color: var(--wq-gold);\n  font-weight: 700;\n  font-size: 12px;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n.wq-title {\n  color: inherit;\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1.15;\n  margin: 0;\n  letter-spacing: -0.01em;\n  text-wrap: balance;\n}\n.wq-line {\n  color: var(--wq-ink-2);\n  font-size: 13px;\n}\n.wq-kv {\n  width: 100%;\n  border-collapse: collapse;\n}\n.wq-kv td {\n  padding: 9px 12px;\n  border-bottom: 1px solid var(--wq-rule);\n  vertical-align: top;\n}\n.wq-kv td:first-child {\n  width: 32%;\n}\n.wq-h {\n  color: inherit;\n  font-size: 16px;\n  font-weight: 800;\n  margin: 6px 0 0;\n}\n.wq-list {\n  margin: 0;\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.wq-list li {\n  list-style: disc;\n}\n.wq-list li::marker {\n  color: var(--wq-gold);\n}\n.wq-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.wq-table th {\n  text-align: left;\n  font-weight: 700;\n  background: var(--wq-mist);\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--wq-rule);\n  font-size: 12.5px;\n}\n.wq-table td {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--wq-rule);\n  vertical-align: top;\n}\n.wq-table .st {\n  color: var(--wq-ink-2);\n  font-size: 12px;\n  white-space: nowrap;\n}\n.wq-note {\n  color: var(--wq-ink-2);\n  font-size: 12px;\n}\n.wq-foot {\n  margin: 0 56px;\n  border-top: 1px solid var(--wq-rule);\n  padding: 8px 0 14px;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 11px;\n  color: var(--wq-ink-2);\n}\n\n#brief-print-root {\n  display: none;\n}\n\n@media print {\n  @page {\n    size: letter;\n    margin: 0;\n  }\n  /* An open modal locks the page scroll, which would cut the printout to one page. */\n  html,\n  body {\n    height: auto !important;\n    overflow: visible !important;\n    background: #fff !important;\n  }\n  #root,\n  .MuiModal-root,\n  .Toastify {\n    display: none !important;\n  }\n  #brief-print-root {\n    display: block !important;\n  }\n  #brief-print-root .wq-page {\n    box-shadow: none;\n    max-width: none;\n    min-height: 11in;\n    break-after: page;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
